import React from 'react';
import { useEffect, useState, useRef } from 'react';
import './help.css';
import Payment from '../../components/payments';

const Help = () => {

  const content1Ref = useRef(null);
  const [content2Height, setContent2Height] = useState(0);

  const updateHeights = () => {
    if (content1Ref.current) {
      const content1height = content1Ref.current.offsetHeight;
      setContent2Height(content1height);
    }
  };

  useEffect(() => {
    updateHeights();

    const handleResize = () => {
      updateHeights();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="help-main">
      <div className="help-section1">
        <h1>ADOPCIA</h1>
        <h3>
          Naše zajačiky prežili ťažké časy – mnohé pochádzajú zo zlých podmienok
          a teraz hľadajú bezpečný a láskyplný domov. <br></br>
          <br></br>Dajte šancu adopcii namiesto kupovania nového zajačika.
        </h3>
        <div className="help-section1-content">
          <div className="help-section1-content-wrapper">
            <div className="help-section1-content-left" ref={content1Ref}>
              <h3>Hľadáme rodiny, ktoré:</h3>
              <div className="points-wrapper">
                <div className="points">
                  <img src="./images/carrot.png" />
                  <p>Svojim zajkom dajú čas a trpezlivosť</p>
                </div>
                <div className="points">
                  <img src="./images/carrot.png" />
                  <p>Poskytnú im láskyplný domov a dostatok pozornosti</p>
                </div>
                <div className="points">
                  <img src="./images/carrot.png" />
                  <p>
                    Sú ochotné prijať zodpovednosť za ich starostlivosť a pohodu
                  </p>
                </div>
                <div className="points">
                  <img src="./images/carrot.png" />
                  <p>
                    Nebudú brať zajka ako vec, ktorému sa budete tešiť len chvíľu
                    a potom vás omrzí
                  </p>
                </div>
              </div>
              <p>
                <span>Zajko sa dožíva 10+ rokov!</span>
              </p>
            </div>
            <div className="help-section1-content-right" style={{ height: `${content2Height}px` }}>
              <h3>Podmienky adopcie:</h3>
              <div className="points-wrapper">
                <div className="points">
                  <img src="./images/carrot.png" />
                  <p>Telefonicky sa spojíme pred adopciou</p>
                </div>
                <div className="points">
                  <img src="./images/carrot.png" />
                  <p>Adopčný poplatok 25€</p>
                </div>
                <div className="points">
                  <img src="./images/carrot.png" />
                  <p>Adopčná zmluva</p>
                </div>
                <div className="points">
                  <img src="./images/carrot.png" />
                  <p>Zajko nepôjde do rodín k veľmi malým detom</p>
                </div>
                <div className='help-section1-content-right-usi'>
                  <img src='./images/zajousi.png' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="help-section-divider">
        <div className="home-divider-left"></div>
        <div className="home-divider-dot"></div>
        <div className="home-divider-image">
          <img src="./images/carrot.png" />
        </div>
        <div className="home-divider-dot"></div>
        <div className="home-divider-right"></div>
      </div>
      <div className="help-section2">
        <h1>Dočasná starostlivosť</h1>
        <div className="help-section2-content-wrapper">
          <div className="help-section2-content-left">
            <img src='./images/zajosec2.png' />
          </div>
          <div className="help-section2-content-right">
            <h3>Ak sa stanete dočasným opatrovateľom zajka, vašimi úlohami budú:</h3>
            <div className="points-wrapper">
              <div className="points">
                <img src="./images/carrot.png" />
                <p>Zabezpečiť mu bezpečný a dočasný domov</p>
              </div>
              <div className="points">
                <img src="./images/carrot.png" />
                <p>V prípade potreby zaisťovať veterinárnu starostlivosť <br></br></p>
              </div>
              <div className="points-comment"><span>náklady hradíme my – OZ Zachráň zajka</span></div>
              <div className="points">
                <img src="./images/carrot.png" />
                <p>Pofotiť zajačika a pomôcť mu nájsť nový milujúci domov</p>
              </div>
              <div className="points-comment"><span>samozrejme s našou podporou a iniciatívou</span></div>
            </div>
          </div>
        </div>
      </div>
      <div className="help-section-divider">
        <div className="home-divider-left"></div>
        <div className="home-divider-dot"></div>
        <div className="home-divider-image">
          <img src="./images/carrot.png" />
        </div>
        <div className="home-divider-dot"></div>
        <div className="home-divider-right"></div>
      </div>
      <div className="help-section3">
        <h1>Finančná podpora</h1>
        <h3>Zajkom môžete pomôcť poslaním peňazí na ich liečbu, veterinárne vyšetrenia a podporiť naše aktivity finančnou formou</h3>
        <Payment />
      </div>
      <div className="help-section-divider">
        <div className="home-divider-left"></div>
        <div className="home-divider-dot"></div>
        <div className="home-divider-image">
          <img src="./images/carrot.png" />
        </div>
        <div className="home-divider-dot"></div>
        <div className="home-divider-right"></div>
      </div>
      <div className="help-section4">
        <h1>2% Z DANÍ</h1>
        <h3>Darujte 2 % z vašich daní našej organizácii a pomôžte nám zachrániť zajačiky. <br></br><br></br>Vaše 2 % môžu urobiť veľký rozdiel v životoch týchto malých a nevinných tvorov!</h3>
        <div className="help-section4-buttons">
          <button onClick={() => window.open('./akonato.pdf', '_blank')}>
            AKO NA TO?
          </button>
          <button onClick={() => window.open('./vyhlasenie.pdf', '_blank')}>
            VYHLÁSENIE
          </button>
        </div>
      </div>
      <div className="help-section-divider">
        <div className="home-divider-left"></div>
        <div className="home-divider-dot"></div>
        <div className="home-divider-image">
          <img src="./images/carrot.png" />
        </div>
        <div className="home-divider-dot"></div>
        <div className="home-divider-right"></div>
      </div>
      <div className="help-section5">
        <h1>ĎAKUJEME ZA POMOC!</h1>
        <h3>Veterinárnu starostlivosť	a finančnú podporu pre zachránené zajačiky nám poskytujú:</h3>
        <div className="help-section5-images">
          <img src='./images/veterinka.png' />
          <img src='./images/marfilvet.jpg' />
          <a href='https://bbzoo.sk' target='_blank'><img src='./images/bbzoo.png' /></a>
        </div>
      </div>
    </div>
  );
};

export default Help;
